import {NavLink} from "react-router-dom";
import React, {memo} from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    link: {
        whiteSpace: "nowrap"
    }
})

const MenuItemLink = ({to, children, exact = false, activeClassName = "active bold-font"}) => {

    const classes = useStyles()

    return (<NavLink className={classes.link} exact={exact} to={to} activeClassName={activeClassName}>
            {children}
        </NavLink>);
}

export default memo(MenuItemLink)
